import TYPES from './types';

export const openLayer = () => {
  return { type: TYPES.toggleLayer, payload: 'search' }
};

export const closeLayer = () => ({
  type: TYPES.toggleLayer, payload: null
});
